var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ height: '42px' })},[_c('div',{staticClass:"topbar_middle"},[_c('iconSymbol',{staticClass:"topbar_logo",attrs:{"name":'math-logo'}}),_c('div',{staticClass:"topbar_name"},[_vm._v("EdrawMath")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }